import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

const statusStyles = {
  success: "bg-[#DBF8E6] text-[#3BB266]",
  pending: "bg-[#FDEAD5] text-[#FF9500] ",
  secondary: "bg-[#EFF1F4] text-[#5B708E] ",
  primary:"bg-[#ECF2FC] text-primary",
  danger:"bg-[#FDECEC] text-[#EF4444]",
  info:"bg-[#E6D7F9] text-[#772ED3]"

};

export default function StatusBadge({ status, text, className, onClick }) {
  return (
    <span
      className={clsx(
        `inline-flex w-fit text-nowrap text-xs items-center capitalize rounded-full px-3 py-1 font-semibold ${className}`,
        statusStyles[status?.toLowerCase()],
        onClick && "cursor-pointer hover:opacity-80"
      )}
      onClick={onClick}
    >
      {text}
    </span>
  );
}

StatusBadge.propTypes = {
  status: PropTypes.oneOf(["success", "pending", "Blacklist","primary","danger"]).isRequired,
  className:PropTypes.string,
  text:PropTypes.string.isRequired,
  onClick: PropTypes.func
};
